import React, {
  useState,
  useRef,
  useEffect,
  useImperativeHandle,
  forwardRef,
} from "react";
import { Autocomplete, TextField } from "@mui/material";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import CustomDatePicker from "../../utilities/CustomDatePicker";
import moment from "moment";

// -----------------------------date picker loading date------------------------------

export const LoadingDate = React.memo(
  forwardRef((props, ref) => {
    const refDatePicker = useRef();
    const [actualLoadingDate, setActualLoadingDate] = useState(null);

    const handleLoadingDateChange = (newValue) => {
      setActualLoadingDate(moment(newValue).format("YYYY-MM-DD"));
    };

    useEffect(() => {
      if (props.data.actualLoadingDate) {
        setActualLoadingDate(props.data.actualLoadingDate);
      }
    }, [props.data]);

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          if (actualLoadingDate !== null) {
            return moment(actualLoadingDate).format("YYYY-MM-DD");
          }
        },
      };
    });
    return (
      <CustomDatePicker
        format={"dd-MM-yyyy"}
        name={"actualLoadingDate"}
        value={
          actualLoadingDate
            ? actualLoadingDate
            : !props.data.actualLoadingDate
            ? null
            : props.data.actualLoadingDate
        }
        handleChange={handleLoadingDateChange}
        ref={refDatePicker}
      />
    );
  })
);

// ------------------------- Actual Container Type-------------------------------------

export const ActualContainerType = React.memo(
  forwardRef((props, ref) => {
  const shippingTypeUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.containerByShippingType}`;

  const refActualCntrType = useRef();
  const [actualCntrTypeOptions, setActualCntrTypeOptions] = useState([]);
  const [actualCntrType, setActualCntrType] = useState("");
  const [actualCntrTypeId, setActualCntrTypeId] = useState("");

  const getShippingType = async () => {
    const shippingType = await OAuthService.getList(`${shippingTypeUrl}/SEA`);
    const actualContainer = shippingType.data.map((type) => {
      return {
        value: type.containerId,
        label: type.name,
      };
    });
    setActualCntrTypeOptions(actualContainer);
  };

  useEffect(() => {
    getShippingType();
  }, []);

  const handleActualContainerTypeChange = (e, data) => {
    setActualCntrType(data.label);
    setActualCntrTypeId(data.value);
  };

  useEffect(() => {
    const actualCntrTypeName = props?.data?.actualContainerType?.name
      ? props?.data?.actualContainerType?.name
      : props?.data?.actualContainerType;
    if (actualCntrTypeName) {
      setActualCntrType(actualCntrTypeName);
    }
  }, [props.data]);

  useEffect(() => {
    const actualCntrTypeId = props?.data?.actualContainerType?.containerId
      ? props?.data?.actualContainerType?.containerId
      : props?.data?.actualCntrTypeId;
    if (actualCntrTypeId) {
      setActualCntrTypeId(actualCntrTypeId);
    }
  }, []);

  useImperativeHandle(ref, () => {
    return {
      getValue() {
        const rowData = props?.node;
        rowData.setDataValue("actualCntrTypeId", actualCntrTypeId);
        return actualCntrType;
      },
    };
  });
  return (
    <div>
      <Autocomplete
        options={actualCntrTypeOptions}
        value={
          actualCntrType && actualCntrTypeOptions.length > 0
            ? actualCntrTypeOptions.filter(
                (obj) => obj.label.trim() === actualCntrType.trim()
              )
              ? actualCntrTypeOptions.filter(
                  (obj) => obj.label.trim() === actualCntrType.trim()
                )[0]
              : ""
            : ""
        }
        onChange={handleActualContainerTypeChange}
        disableClearable
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={"Select "}
            inputRef={refActualCntrType}
          />
        )}
      />
    </div>
  );
})
);

// ---------------------------- Select Container Status------------------------------------------

export const ContainerStatus = React.memo(
  forwardRef((props, ref) => {
  // const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.containerByShippingType}`;
  const initialValue = [
    { value: "", label: "Forwarder_Info_Pending" },
    { value: "", label: "Tour_Planning_Pending" },
    { value: "", label: "Tour_Planning_Reconciled" },
    { value: "", label: "Tour_Planning_not_Reconciled" },
    { value: "", label: "Document_Upload_Pending" },
    { value: "", label: "Document_Upload_In_Progress" },
    { value: "", label: "Document_Upload_Completed" },
    { value: "", label: "Completed" },
  ];
  const refContainerStatus = useRef();
  const [containerStatusOptions, setContainerStatusOptions] =
    useState(initialValue);
  const [containerStatus, setContainerStatus] = useState("");

  const handleContainerStatusChange = (e, data) => {
    setContainerStatus(data.label);
  };

  useEffect(() => {
    const containerStatus = props?.value;
    if (containerStatus) {
      setContainerStatus(containerStatus);
    }
  }, [props.data]);

  useImperativeHandle(ref, () => {
    return {
      getValue() {
        return containerStatus;
      },
    };
  });
  return (
    <Autocomplete
      options={containerStatusOptions}
      value={
        containerStatus && containerStatusOptions.length > 0
          ? containerStatusOptions.filter(
              (obj) => obj.label.trim() === containerStatus.trim()
            )
            ? containerStatusOptions.filter(
                (obj) => obj.label.trim() === containerStatus.trim()
              )[0]
            : ""
          : ""
      }
      onChange={handleContainerStatusChange}
      disableClearable
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={"Select "}
          inputRef={refContainerStatus}
        />
      )}
    />
  );
})
);

// ---------------------------- customtext editor------------------------------------------

export const CustomTextEditor = React.memo(
  forwardRef((props, ref) => {
  const refValue = useRef();
  const [value, setValue] = useState("");

  const handleVesselNoChange = (e) => {
    setValue(e.target.value);
  };
  useEffect(() => {
    const value = props?.value;
    if (value) {
      setValue(value);
    }
  }, [props.data]);
  useImperativeHandle(ref, () => {
    return {
      getValue() {
        return value;
      },
    };
  });
  return (
    <TextField
      className="mt-8 mb-16"
      required
      type="text"
      variant="outlined"
      name={props.colDef.field}
      value={value}
      onChange={handleVesselNoChange}
      inputRef={refValue}
      //   InputLabelProps={{
      //     shrink: true,
      // }}
    />
  );
})
);

// -----------------------------date picker ETD------------------------------

export const ETDDate = React.memo(
  forwardRef((props, ref) => {
  const refDatePicker = useRef();
  const [etd, setETD] = useState(null);

  const handleLoadingDateChange = (newValue) => {
    setETD(moment(newValue).format("YYYY-MM-DD"));
  };

  useEffect(() => {
    if (props.data.etd) {
      setETD(props.data.etd);
    }
  }, [props.data]);

  useImperativeHandle(ref, () => {
    return {
      getValue() {
        if (etd !== null) {
          return moment(etd).format("YYYY-MM-DD");
        }
      },
    };
  });
  return (
    <CustomDatePicker
      format={"dd-MM-yyyy"}
      name={"etd"}
      value={etd ? etd : !props.data.etd ? null : props.data.etd}
      handleChange={handleLoadingDateChange}
      ref={refDatePicker}
    />
  );
})
);

// -----------------------------date picker ETA------------------------------

export const ETADate = React.memo(
  forwardRef((props, ref) => {
  const refDatePicker = useRef();
  const [eta, setETA] = useState(null);

  const handleLoadingDateChange = (newValue) => {
    setETA(moment(newValue).format("YYYY-MM-DD"));
  };

  useEffect(() => {
    if (props.data.eta) {
      setETA(props.data.eta);
    }
  }, [props.data]);

  useImperativeHandle(ref, () => {
    return {
      getValue() {
        if (eta !== null) {
          return moment(eta).format("YYYY-MM-DD");
        }
      },
    };
  });
  return (
    <CustomDatePicker
      format={"dd-MM-yyyy"}
      name={"eta"}
      value={eta ? eta : !props.data.eta ? null : props.data.eta}
      handleChange={handleLoadingDateChange}
      ref={refDatePicker}
    />
  );
})
);
